export default function Header()
{
    return(
    <header>
    {/* <nav className='nav'>
        <img  src={logo} className='nav-logo' />

        <ul className='nav-items'>
        <li>Capture</li>
        <li>Remote</li>
        </ul>

    </nav> */}
    </header>
    )
}